var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFifa18({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_394",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29045",
    "data-name": "Group 29045",
    transform: "translate(-3746 4801)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 3746, -4801)",
    filter: "url(#Ellipse_394)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_394-2",
    "data-name": "Ellipse 394",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-fifa18",
    transform: "translate(3761.919 -4790.409)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50757",
    "data-name": "Path 50757",
    d: "M34.616,17.541H32.98V19.69h.79a.6.6,0,0,1,.617.617v8.069h2.607v-8.45A2.308,2.308,0,0,0,34.616,17.541Z",
    transform: "translate(-5.233 -0.021)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50758",
    "data-name": "Path 50758",
    d: "M42.943,17.409c2.35,0,3.508,1.088,3.508,2.995A2.528,2.528,0,0,1,45.085,22.8a2.59,2.59,0,0,1,1.525,2.551c0,1.276-.436,3.148-3.674,3.148s-3.674-1.872-3.674-3.148A2.589,2.589,0,0,1,40.787,22.8,2.528,2.528,0,0,1,39.422,20.4C39.435,18.5,40.593,17.409,42.943,17.409Zm0,4.451a.989.989,0,0,0,.784-.256,1.385,1.385,0,0,0,.235-.964,1.1,1.1,0,0,0-.256-.9,1.353,1.353,0,0,0-1.525,0,1.111,1.111,0,0,0-.256.9,1.358,1.358,0,0,0,.235.964A.977.977,0,0,0,42.943,21.86Zm0,4.54a1.154,1.154,0,0,0,.748-.173c.235-.167.353-.4.353-1.088a1.2,1.2,0,0,0-.312-1.026,1.137,1.137,0,0,0-.8-.188,1.106,1.106,0,0,0-.8.194,1.2,1.2,0,0,0-.312,1.026c0,.686.124.922.353,1.088a1.306,1.306,0,0,0,.764.167Z",
    transform: "translate(-6.233)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50759",
    "data-name": "Path 50759",
    d: "M27.141,17.508h-2.3a2.314,2.314,0,0,0-2.378,2.378v8.451h2.614V20.275a.6.6,0,0,1,.617-.617h.617a.562.562,0,0,1,.617.617V22.5H25.547v2.149h1.379v3.688h2.607V19.893a2.328,2.328,0,0,0-2.392-2.385Z",
    transform: "translate(-3.56 -0.016)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50760",
    "data-name": "Path 50760",
    d: "M13.526,19.906v8.436h2.635V24.01H19.1V21.84H16.153V20.295a.6.6,0,0,1,.617-.624h3.4V17.508H15.925A2.332,2.332,0,0,0,13.526,19.906Z",
    transform: "translate(-2.139 -0.016)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50761",
    "data-name": "Path 50761",
    d: "M9.1,17.508h2.627V28.336H9.1Z",
    transform: "translate(-1.434 -0.016)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50762",
    "data-name": "Path 50762",
    d: "M.081,19.906v8.436H2.716V24.01H5.655V21.84H2.715V20.295a.6.6,0,0,1,.617-.624h3.4V17.508H2.479A2.331,2.331,0,0,0,.081,19.906Z",
    transform: "translate(0 -0.016)",
    fill: "#37474f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFifa18);
export default __webpack_public_path__ + "static/media/fifa18.c285a4670c2c7502b23b719f1d66a417.svg";
export { ForwardRef as ReactComponent };